<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-aria/visually-hidden';
import {HeaderInfo, PropTable} from '@react-spectrum/docs';
import packageData from '@react-aria/visually-hidden/package.json';

---
category: Utilities
keywords: [hidden, aria, assistive technology]
---

# VisuallyHidden

<p>{docs.exports.VisuallyHidden.description}</p>

<HeaderInfo
  packageData={packageData}
  componentNames={['VisuallyHidden']} />

## Introduction

`VisuallyHidden` is a utility component that can be used to hide its children visually,
while keeping them visible to screen readers and other assistive technology. This would
typically be used when you want to take advantage of the behavior and semantics of a
native element like a checkbox or radio button, but replace it with a custom styled
element visually.

## Props

<PropTable links={docs.links} component={docs.exports.VisuallyHidden} />

## Example

See [useRadioGroup](useRadioGroup.html#styling) and [useCheckbox](useCheckbox.html#styling)
for examples of using `VisuallyHidden` to hide native form elements visually.
